/** Collapses consecutive duplicate "dispensary" words to a single one, keeping the first occurrence's casing. */
const DUPLICATE_DISPENSARY = /\b(dispensary)\b(?:\s+dispensary\b)+/gi;

export const dedupeDispensary = (value: string): string =>
  value.replace(DUPLICATE_DISPENSARY, '$1');
